import { render } from "./NotFound.vue?vue&type=template&id=9a6b06b0"
import script from "./NotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/components/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a6b06b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a6b06b0', __exports__)) {
    api.reload('9a6b06b0', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=9a6b06b0", () => {
    api.rerender('9a6b06b0', render)
  })

}


export default __exports__